import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import BuscaCliente from "../../../../components/personSearch";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import message from "../../../../utils/messages";
import revisaoCotaInstalacaoService from "../../../../services/serviceRevisaoCotaInstalacao";
import serviceClienteInstalacao from "../../../../services/serviceClienteInstalacao";
import { toast } from "react-toastify";

interface iDialog {
    success?: any;
    onClose: any;
    data: {
        open: any;
        nomeCliente: string;
        revisaoCotaInstalacaoID: number;
    };
}

const DialogSelectClient: React.FC<iDialog> = ({ data, onClose, success }: iDialog) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [newClienteInstalacao, setNewClienteInstalacao] = useState({
        nomeCliente: "",
        clienteID: 0,
        instalacaoID: 0,
        numeroInstalacao: "",
        clienteInstalacaoID: 0,
    });
    const [value, setValue] = useState({
        nomeCliente: "",
        idCliente: 0,
        instalacaoID: 0,
        numeroInstalacao: "",
        clienteInstalacaoID: 0,
    });
    const [searchClient, setSearchClient] = useState({
        open: false,
        nomeCliente: "",
        instalacaoID: 0,
        numeroInstalacao: "",
        clienteInstalacaoID: 0,
    });

    const getWithFilter = async (filters: any) => {
        setLoading(true);
        await serviceClienteInstalacao
            .getWithFilter({ ...filters, take: 1, currentPage: 1 })
            .then((result) => {
                setValue({
                    nomeCliente: result?.data.content[0].nomeCliente,
                    idCliente: result?.data.content[0].clienteID,
                    instalacaoID: result?.data.content[0].instalacaoID,
                    numeroInstalacao: result?.data.content[0].numeroInstalacao,
                    clienteInstalacaoID: 0,
                });
            })
            .catch((err) => {
                toast.error(err);
                setValue({
                    nomeCliente: "",
                    idCliente: 0,
                    instalacaoID: 0,
                    numeroInstalacao: "",
                    clienteInstalacaoID: 0,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (data.nomeCliente && data.nomeCliente.length > 0) {
            (async () => {
                await getWithFilter({ nomeCliente: data.nomeCliente });
            })();
        }
    }, [data]);

    useEffect(() => {
        if (newClienteInstalacao) {
            setValue({
                nomeCliente: newClienteInstalacao.nomeCliente,
                idCliente: newClienteInstalacao.clienteID,
                instalacaoID: newClienteInstalacao.clienteInstalacaoID,
                numeroInstalacao: newClienteInstalacao?.numeroInstalacao,
                clienteInstalacaoID: 0,
            });
        }
    }, [newClienteInstalacao]);

    const handleUpdate = () => {
        if (data.revisaoCotaInstalacaoID && newClienteInstalacao.clienteID) {
            revisaoCotaInstalacaoService
                .update({
                    revisaoCotaInstalacaoID: data.revisaoCotaInstalacaoID,
                    clienteInstalacaoID: newClienteInstalacao.clienteInstalacaoID,
                })
                .then((result) => {
                    toast.success(message.updateSucess);
                    onClose();
                    success();
                })
                .catch((err) => {
                    toast.error(message.updateError, err);
                });
        }
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={data.open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Typography>Editar</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {!loading ? (
                        <TextField
                            id="cliente"
                            fullWidth
                            value={value.nomeCliente}
                            onClick={() =>
                                setSearchClient({
                                    open: true,
                                    nomeCliente: value.nomeCliente,
                                    instalacaoID: value.instalacaoID,
                                    numeroInstalacao: value.numeroInstalacao,
                                    clienteInstalacaoID: 0,
                                })
                            }
                            label="Cliente"
                        />
                    ) : (
                        "Carregando..."
                    )}
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        id="cancelar"
                        variant="contained"
                        color="warning"
                        autoFocus
                        onClick={() => {
                            onClose();
                            setValue({
                                nomeCliente: "",
                                idCliente: 0,
                                instalacaoID: 0,
                                numeroInstalacao: "",
                                clienteInstalacaoID: 0,
                            });
                        }}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        id="salvar"
                        variant="contained"
                        autoFocus
                        onClick={handleUpdate}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>

            <BuscaCliente
                returnData={(item: any) => {
                    setNewClienteInstalacao(item);
                }}
                data={{
                    open: searchClient.open,
                    nomeCliente: searchClient.nomeCliente,
                    instalacaoID: searchClient.instalacaoID,
                    numeroInstalacao: searchClient.numeroInstalacao,
                }}
                onClose={() =>
                    setSearchClient({
                        open: false,
                        nomeCliente: "",
                        instalacaoID: 0,
                        numeroInstalacao: "",
                        clienteInstalacaoID: 0,
                    })
                }
            />
        </>
    );
};

export default DialogSelectClient;
